export default __webpack_public_path__ + "static/media/glodny-sm-light.259820c9.svg";